import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getAssetUrl } from 'src/app/shared/asset';
import { Theme } from 'src/app/theme/theme';
import { AvatarPart } from '../../tribe';

@Component({
    selector: 'app-avatar-part',
    templateUrl: './avatar-part.component.html',
    styleUrls: ['./avatar-part.component.scss'],
    standalone: false
})
export class AvatarPartComponent {
  @Input()
  theme: Theme;

  @Input()
  avatarPart?: AvatarPart;

  @Input()
  selected: boolean;

  @Output()
  click = new EventEmitter<boolean>();

  onClick() {
    this.click.emit(true);
  }

  get backgroundStyle() {
    const style: { 'background-color': string; opacity?: string } = {
      'background-color': this.selected ? this.theme.primaryColor : this.theme.backgroundColor
    };
    if (this.avatarPart && !this.avatarPart.usable && !this.selected) {
      style.opacity = '40%';
    }
    return style;
  }

  get priceBoxStyle() {
    return {
      'background-color': this.selected ? '#ffffff' : this.theme.primaryColor
    };
  }

  get partUrl() {
    return getAssetUrl(this.avatarPart?.image.path);
  }
}
